import React from 'react'

import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()

// Remember old renderer, if overridden, or proxy to default renderer
var defaultRender =
  md.renderer.rules.link_open ||
  function(tokens, idx, options, env, self) {
    return self.renderToken(tokens, idx, options)
  }

md.renderer.rules.link_open = function(tokens, idx, options, env, self) {
  // If you are sure other plugins can't add `target` - drop check below
  var aIndex = tokens[idx].attrIndex('target')

  var aHref = tokens[idx].attrs.find(d => d[0] === 'href')[1]

  if (aHref.indexOf('uppercanadasoap.com') === -1) {
    if (aIndex < 0) {
      tokens[idx].attrPush(['target', '_blank']) // add new attribute
    } else {
      tokens[idx].attrs[aIndex][1] = '_blank' // replace value of existing attr
    }
  }

  // pass token to default renderer.
  return defaultRender(tokens, idx, options, env, self)
}

const MarkdownStringRenderer = ({ markdownString }) => (
  <div
    dangerouslySetInnerHTML={{
      __html: md.render(markdownString || ''),
    }}
  ></div>
)

export default MarkdownStringRenderer
